import { toFormData } from '../lib/utils/forms';
import { axiosAPI } from './axios-instance';
import { ApiResponse } from './lib/types';

export type ApiParticipantsListRequest = {
    name: string;
    email: string;
    phone: string;
    agreementChecked: number;
    agreementCheckedProcessingPersonalData: number;
    utm_source?: string;
    utm_medium?: string;
    utm_campaign?: string;
    utm_term?: string;
    utm_content?: string;
};

export type ParticipantsListResponseData = {
    title: string;
    description: string;
};

type ApiParticipantsListResponseData = {
    title: string;
    message: string;
};

export type ApiParticipantsListResponse = ApiResponse<ApiParticipantsListResponseData>;

export type AppParticipantsListResponse = ApiResponse<ParticipantsListResponseData>;

const transformApiResponse = (response: ApiParticipantsListResponse): AppParticipantsListResponse => {
    return {
        ...response,
        data: response.data
            ? {
                  title: response.data.title,
                  description: response.data.message,
              }
            : undefined,
    };
};

export const postParticipantsList = (body: ApiParticipantsListRequest): Promise<AppParticipantsListResponse> =>
    axiosAPI
        .post<ApiParticipantsListResponse>('/v1/feedback/participants-list', toFormData(body))
        .then((res) => transformApiResponse(res.data));
